import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import env from '../../../util/env';
import {currentResource, labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import {serviceURL, ControlADCConstants} from '../../../util/uiconstants';
import ReactSelect from '../../Common/SelectDropdown/SelectDropdown';
import ContentSwitcher from '../../Common/BaseComponentWrappers/MotifContentSwitcher';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import EllipseControl from '../../Common/EllipsesControl/EllipsesControl';
import {getControlById} from '../../../actions/Control/controlaction';
import {getITApplication} from '../../../actions/ITApplication/itapplicationaction';
import Checkbox from '../../Common/BaseComponentWrappers/MotifCheckbox';
import Button from '../../Common/BaseComponentWrappers/MotifButton';

export function EditControlContainer(props) {
	const {controlContainerRef, isShared, engagementId, controlId, documentId} = props;
	const [error, setError] = useState(''),
		[showLoader, setShowLoader] = useState(true),
		[itApplicationList, setitApplicationList] = useState(''),
		[selectedFrequencyType, setSelectedFrequencyType] = useState(''),
		[selectedControlType, setSelectedControlType] = useState(''),
		[activeDesignEffectivenesIndex, setActiveDesignEffectivenesIndex] = useState(null),
		[activeOperatingEffectivenesIndex, setActiveOperatingEffectivenesIndex] = useState(''),
		[activeControlTestingIndex, setActiveControlTestingIndex] = useState(''),
		[value, setValue] = useState(0),
		[isLowerRisk, setIsLowerRisk] = useState(false),
		[isIPEManuallyTested, setIsIPEManuallyTested] = useState(false);

	const controlsDetails = useSelector((store) => store.controlsDetails),
		itapplicationData = useSelector((store) => store.itapplicationData),
		engagement = useSelector((store) => store.engagement);
	const dispatch = useDispatch();

	//Fill control Object
	const fillControlObject = () => {
		let itApplication = [];

		if (itApplicationList && itApplicationList.length > 0) {
			itApplicationList.map((itApp) => {
				if (itApp.isSelected) {
					itApplication.push(itApp.id);
				}
			});
		}

		let controlTesting = null;
		if (activeControlTestingIndex) {
			controlTesting = activeControlTestingIndex === 1;
		}
		let controlIsEffective = null;
		if (activeOperatingEffectivenesIndex) {
			controlIsEffective = activeOperatingEffectivenesIndex === 1;
		}

		let data = {
			controlFrequencyTypeId:
				selectedFrequencyType && selectedFrequencyType.value !== -1 ? selectedFrequencyType.value : 'none',
			controlTypeId: selectedControlType && selectedControlType.value !== -1 ? selectedControlType.value : 'none',
			iTApplications: itApplication,
			controlDesignEffectivenessTypeId: activeDesignEffectivenesIndex,
			isEffective: controlIsEffective,
			hasControlTesting: controlTesting,
			isLowerRisk: isLowerRisk,
			isIPEManuallyTested: showIsIPEManuallyTestedRow() && isIPEManuallyTested
		};
		controlContainerRef.current.selectedControl = data;
	};
	// Save frequency type
	const onControlFrequencyType = (option) => {
		setSelectedFrequencyType(option);
	};

	// Save control type
	const onControlType = (option) => {
		if (option && option.value !== 1 && option.value !== 2 && itApplicationList && itApplicationList.length > 0) {
			itApplicationList.map((item) => {
				if (!item.isServiceOrganization) {
					item.isSelected = false;
				}
			});
			setitApplicationList(itApplicationList);
		}
		setSelectedControlType(option);
	};

	// Save DesignEffectiveness
	const toggleDesignEffectivenessClick = (e) => {
		let selectedId = Number(e.currentTarget.id);
		selectedId !== activeDesignEffectivenesIndex
			? setActiveDesignEffectivenesIndex(selectedId)
			: setActiveDesignEffectivenesIndex(null);
	};

	// Save OpertaingEffectiveness type
	const toggleOpertaingEffectivenessClick = (e) => {
		let selectedOperatingId = Number(e.currentTarget.id);
		selectedOperatingId !== activeOperatingEffectivenesIndex
			? setActiveOperatingEffectivenesIndex(selectedOperatingId)
			: setActiveOperatingEffectivenesIndex('');
	};

	// Save Control Testing type
	const toggleTestingClick = (e) => {
		let selectedTestingId = Number(e.currentTarget.id);
		selectedTestingId !== activeControlTestingIndex
			? setActiveControlTestingIndex(selectedTestingId)
			: setActiveControlTestingIndex('');
	};

	// Save Lower Risk type
	const handleOnCheckChange = (e) => {
		setIsLowerRisk(!isLowerRisk);
	};

	// check precondition to display Lower Risk type
	const checkPreRequirementTodisplayLowerRisk = () => {
		if (
			engagement.isDigitalGamEngagement ||
			(engagement.gaasCountryId === ControlADCConstants.gaasCountryId &&
				engagement.auditProfileAnswerOptionId === ControlADCConstants.auditProfileAnswerOptionId)
		) {
			return true;
		}
		return false;
	};

	const showIsIPEManuallyTestedRow = () => {
		let show = false;

		if (selectedControlType && selectedControlType.value === ControlADCConstants.ITDependentcontrolType) {
			show = show || !engagement.isIntegratedAudit;
			show = show || engagement.gaasCountryId !== ControlADCConstants.gaasCountryId;
		}
		return show;
	};

	// enable disable itapp Lower Risk type
	const disableItApp = (isServiceOrganization) => {
		if (isShared) {
			return isShared;
		}
		if (
			selectedControlType.value !== -1 &&
			selectedControlType.value !== ControlADCConstants.ITApplicationControlType &&
			selectedControlType.value !== ControlADCConstants.ITDependentcontrolType &&
			!isServiceOrganization
		) {
			return true;
		}
		return isShared;
	};

	// Save itApp & So
	const handleOnitAppCheckChange = (e) => {
		if (e && e.currentTarget) {
			let itAppData = itApplicationList.find((itApp) => itApp.id === Number(e.currentTarget.id));
			if (itAppData) {
				itAppData.isSelected = !itAppData.isSelected;
			}
			setitApplicationList(itApplicationList);
			setValue(value + 1);
		}
	};

	// getAggregateITEvaluationName.
	const getAggregateITEvaluationName = (data) => {
		let aggregateITEvaluationLabel = labels.notSelected;
		if (data && data.aggregateITEvaluationTypeId) {
			currentResource.aggregateITEvaluationType.map((item) => {
				if (item.value === data.aggregateITEvaluationTypeId) {
					aggregateITEvaluationLabel = item.label;
				}
			});
		}
		return <EllipseControl content={aggregateITEvaluationLabel} tooltip={aggregateITEvaluationLabel} noOfLines={1} />;
	};

	const getItAppName = (data) => {
		if (data.isServiceOrganization) {
			return (
				<>
					<span className="ITTextBold">{labels.soBadge}</span> {data.itApplicationName}
				</>
			);
		}
		return (
			<>
				<span className="ITTextBold">{labels.itBadge}</span> {data.itApplicationName}
			</>
		);
	};

	const formatSelectedLabel = ({label}) => {
		return (
			<section className="selectText">
				<EllipseControl id="formatControlLabel" content={label} tooltip={label} noOfLines={1} />
			</section>
		);
	};

	useEffect(() => {
		if (!showLoader) {
			// Frequency
			if (controlsDetails && controlsDetails.controlFrequencyTypeId) {
				currentResource.controlFrequencyType.map((item) => {
					if (item.value === controlsDetails.controlFrequencyTypeId) {
						setSelectedFrequencyType(item);
					}
				});
			} else {
				setSelectedFrequencyType({value: -1, label: labels.SelectFrequency, title: labels.SelectFrequency});
			}

			// Control Type
			if (controlsDetails && controlsDetails.controlTypeId) {
				currentResource.controlType.map((item) => {
					if (item.value === controlsDetails.controlTypeId) {
						setSelectedControlType(item);
					}
				});
			} else {
				setSelectedControlType({value: -1, label: labels.SelectControlType, title: labels.SelectControlType});
			}

			// Itapplication
			if (itapplicationData && itapplicationData.data && itapplicationData.data.length > 0) {
				let ITApplicationList = [];
				itapplicationData.data.map((item) => {
					let aggregateITEvaluationTypeId,
						serviceOrganization,
						isSelected = false;

					if (controlsDetails && controlsDetails.itApplications && controlsDetails.itApplications.length > 0) {
						aggregateITEvaluationTypeId = item.aggregateITEvaluationTypeId;
						serviceOrganization = item.isServiceOrganization;
						let itAppData = controlsDetails.itApplications.find((itApp) => {
							return itApp.id === item.id;
						});
						if (itAppData) {
							isSelected = true;
							aggregateITEvaluationTypeId = itAppData.aggregateITEvaluationTypeId;
							serviceOrganization = itAppData.isServiceOrganization;
						}
					}
					let itApplicationObject = {
						id: item.id,
						isServiceOrganization: serviceOrganization,
						itApplicationName: item.itApplicationName,
						strategyTypeId: item.strategyTypeId,
						aggregateITEvaluationTypeId: aggregateITEvaluationTypeId,
						isSelected: isSelected
					};
					ITApplicationList.push(itApplicationObject);
				});
				ITApplicationList.sort(Utility.sortByMultipleKey(['itApplicationName']));
				setitApplicationList(ITApplicationList);
			}

			// design effectiveness
			if (controlsDetails && controlsDetails.controlDesignEffectivenessTypeId) {
				setActiveDesignEffectivenesIndex(controlsDetails.controlDesignEffectivenessTypeId);
			}

			// operating effectiveness
			if (controlsDetails && controlsDetails.isEffective !== null) {
				controlsDetails.isEffective ? setActiveOperatingEffectivenesIndex(1) : setActiveOperatingEffectivenesIndex(2);
			}

			// testing
			if (controlsDetails && controlsDetails.hasControlTesting !== null) {
				controlsDetails.hasControlTesting ? setActiveControlTestingIndex(1) : setActiveControlTestingIndex(2);
			}

			// lower risk
			if (controlsDetails && controlsDetails.isLowerRisk) {
				setIsLowerRisk(true);
			}

			// isIPEManuallyTested
			if (controlsDetails && controlsDetails.isIPEManuallyTested) {
				setIsIPEManuallyTested(controlsDetails.isIPEManuallyTested);
			}
		}
	}, [itapplicationData, controlsDetails, showLoader]);

	useEffect(() => {
		let url = `${env.getBaseURL(serviceURL, engagementId)}ITApplications?includeControl=true`;
		let controlExpand = 'itapplications';
		dispatch(getITApplication(url)).then(() => {});
		dispatch(getControlById(engagementId, controlId, documentId, controlExpand))
			.then(() => {
				setShowLoader(false);
			})
			.catch(() => {
				setShowLoader(false);
			});
	}, []);

	return (
		<StyledEditControlWrapper className="StyledEditControlWrapper">
			{showLoader ? (
				<LoadingIndicator show view="blockview" styleName="LoadingIndicator" />
			) : (
				<>
					<section className="controlRow">
						<section className="controlFrequencyType">
							<ReactSelect
								formLabel={labels.frequency}
								formatOptionLabel={formatSelectedLabel}
								groupHeading
								id="ControlFrequencyType"
								isSearchable
								defaultValue={selectedFrequencyType}
								options={currentResource.controlFrequencyType}
								onChange={onControlFrequencyType}
								value={selectedFrequencyType}
								noOptionsMessage={() => labels.noResultsFound}
								isDisabled={isShared}
							/>
						</section>
						<section className="controlType">
							<ReactSelect
								formLabel={labels.type}
								groupHeading
								id="controlType"
								formatOptionLabel={formatSelectedLabel}
								isSearchable
								defaultValue={selectedControlType}
								options={currentResource.controlType}
								onChange={onControlType}
								value={selectedControlType}
								noOptionsMessage={() => labels.noResultsFound}
								isDisabled={isShared}
							/>
						</section>
						<section className="lowerRisk">
							{checkPreRequirementTodisplayLowerRisk() && (
								<Checkbox
									styleName="section-checkbox"
									id="cckTesting"
									ellipse
									label={labels.controlLowerRisk}
									name={labels.controlLowerRisk}
									title={labels.controlLowerRisk}
									checked={isLowerRisk}
									onChange={handleOnCheckChange}
								/>
							)}
						</section>
					</section>
					{showIsIPEManuallyTestedRow() && (
						<section className="ipe-manually-tested-row">
							<Checkbox
								label={labels.isIPEManuallyTested}
								name={labels.isIPEManuallyTested}
								title={labels.isIPEManuallyTested}
								className={'ipe-manually-tested-check-box'}
								checked={isIPEManuallyTested}
								ellipse
								onChange={() => {
									setIsIPEManuallyTested(!isIPEManuallyTested);
								}}
								styleName={'ipe-manually-tested-check-box-wrapper'}
							/>
						</section>
					)}
					<section className="controlRow">
						<section className="controldesignEffectiveness">
							<section className="controldesignEffectivenessLabel">{labels.designEffectiveness}</section>
							<ContentSwitcher
								children={currentResource.controlEffectivenessType.map((data, index) => {
									return (
										<Button
											name={data.ControlEffectivenessTypeName}
											onClick={toggleDesignEffectivenessClick}
											id={data.ControlEffectivenessTypeId}
											variant="secondary"
											className={`${activeDesignEffectivenesIndex === index + 1 ? 'motif-active' : ''}`}
											disabled={isShared}
											showLabel
											isEllipsed
											buttonLabel={data.ControlEffectivenessTypeName}
											noOfLines={1}
										/>
									);
								})}
							/>
						</section>
						<section className="controlOpertaingEffectiveness">
							<section className="controlOpertaingEffectivenessLabel">
								<EllipseControl
									content={labels.controlOpertaingEffectiveness}
									tooltip={labels.controlOpertaingEffectiveness}
									noOfLines={1}
								/>
							</section>
							<ContentSwitcher
								children={currentResource.controlEffectivenessType.map((data, index) => {
									return (
										<Button
											name={data.ControlEffectivenessTypeName}
											onClick={toggleOpertaingEffectivenessClick}
											id={data.ControlEffectivenessTypeId}
											variant="secondary"
											className={`${activeOperatingEffectivenesIndex === index + 1 ? 'motif-active' : ''}`}
											disabled={isShared}
											showLabel
											isEllipsed
											buttonLabel={data.ControlEffectivenessTypeName}
											noOfLines={1}
										/>
									);
								})}
							/>
						</section>
						<section className="controlTesting">
							<section className="controlTestingLabel">
								<EllipseControl content={labels.testingTitle} tooltip={labels.testingTitle} noOfLines={1} />
							</section>
							<ContentSwitcher
								children={currentResource.testing.map((data, index) => {
									return (
										<Button
											name={data.testingDescription}
											onClick={toggleTestingClick}
											id={data.testingId}
											variant="secondary"
											className={`${activeControlTestingIndex === index + 1 ? 'motif-active' : ''}`}
											disabled={isShared}
											showLabel
											isEllipsed
											buttonLabel={data.testingDescription}
											noOfLines={1}
										/>
									);
								})}
							/>
						</section>
					</section>
					<section className="iTAppWrapper">
						<section className="itAppHeading">
							<section className="relatedItText">
								<EllipseControl
									content={labels.relatedITapplicationSOs}
									tooltip={labels.relatedITapplicationSOs}
									noOfLines={1}
								/>
							</section>
							<section className="aggregateItText">
								<EllipseControl
									content={labels.aggregateITevaluations}
									tooltip={labels.aggregateITevaluations}
									noOfLines={1}
								/>
							</section>
						</section>
						<section className="relatedITSelect customScrollbar">
							{itApplicationList &&
								itApplicationList.length > 0 &&
								itApplicationList.map((data) => {
									return (
										<section className="relatedItContainer">
											<section className="relatedItData">
												<Checkbox
													styleName="cckItapp"
													id={data.id}
													ellipse
													label={getItAppName(data)}
													name={data.itApplicationName}
													title={data.itApplicationName}
													checked={data.isSelected}
													disabled={disableItApp(data.isServiceOrganization)}
													onChange={handleOnitAppCheckChange}
												/>
											</section>
											<section
												className={`aggregateItData ${data.aggregateITEvaluationTypeId === 2 ? 'notSelectedData' : ''}`}
											>
												{!disableItApp(data.isServiceOrganization) &&
													data.isSelected &&
													!data.isServiceOrganization &&
													getAggregateITEvaluationName(data)}
											</section>
										</section>
									);
								})}
						</section>
					</section>
					{fillControlObject()}
				</>
			)}
		</StyledEditControlWrapper>
	);
}

export default EditControlContainer;

const StyledEditControlWrapper = styled.section`
	display: flex;
	flex-direction: column;
	.ipe-manually-tested-row {
		padding: var(--px-20) 0;
		line-height: normal;
		.ipe-manually-tested-check-box {
			min-width: var(--px-1000);
		}
	}
	.controlRow {
		display: flex;
		margin: var(--px-10) 0;
		.motif-content-switcher {
			.motif-button {
				width: 50% !important;
			}
		}
		.controlFrequencyType,
		.controldesignEffectiveness,
		.controlTesting {
			width: 48%;
			margin-right: var(--px-10);
		}
		.controlType,
		.controlOpertaingEffectiveness,
		.lowerRisk {
			width: 48%;
			margin-left: auto;
			vertical-align: bottom;
			margin-right: var(--px-10);
		}
		.controldesignEffectivenessLabel,
		.controlOpertaingEffectivenessLabel,
		.controlTestingLabel,
		.lowerRiskLabel {
			padding-bottom: var(--px-5);
			font-size: var(--px-14);
			font-weight: 300;
		}
		.lowerRisk {
			display: inline-flex;
			align-items: center;
			.section-checkbox {
				width: 100%;
			}
		}
	}
	.iTAppWrapper {
		border: var(--px-1) solid var(--neutrals-200);
		margin-top: var(--px-20);
		.itAppHeading {
			background: var(--neutrals-200);
			padding: var(--px-5) var(--px-10);
			font-weight: bold;
			color: var(--neutrals-900);
			.relatedItText {
				display: inline-flex;
				width: calc(100% - var(--px-210));
				padding: 0 var(--px-25);
			}
			.aggregateItText {
				display: inline-flex;
				width: var(--px-200);
			}
		}
	}
	.relatedITSelect {
		max-height: var(--px-300);
		padding: 0 var(--px-10);
		.relatedItContainer {
			display: flex;
			align-items: center;
			padding: var(--px-8) 0;
			min-height: var(--px-40);
			.relatedItData {
				display: inline-flex;
				width: calc(100% - var(--px-250));
				padding-right: var(--px-20);
				.cckItapp {
					width: calc(100% - var(--px-20));
					.motif-checkbox-label {
						width: 100%;
					}
					.ITTextBold {
						color: var(--neutrals-900);
						font-size: var(--px-14);
						font-weight: bold;
						display: inline-block;
						min-width: var(--px-20);
					}
				}
			}
			.aggregateItData {
				display: inline-flex;
				padding-left: var(--px-47);
				line-height: var(--px-20);
				&.notSelectedData {
					color: var(--red-600);
				}
			}
			&:last-child {
				padding-bottom: 0;
			}
		}
		.selectText {
			display: inline-block;
			width: 100%;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			line-height: normal;
			vertical-align: top;
		}
		.react-select-container {
			.react-select__menu {
				.react-select__menu-list {
					.react-select__option {
						line-height: normal;
					}
				}
			}
			.react-select__control {
				.react-select__value-container--is-multi {
					margin-top: var(--px-10);
					line-height: normal;
				}
				.react-select__multi-value {
					background: var(--neutrals-00white);
					align-items: center;
					max-width: var(--px-100);
					margin-top: var(--px-5);
					.react-select__multi-value__label {
						padding: var(--px-3) var(--px-3) var(--px-3) var(--px-6);
					}
				}
				.react-select__multi-value__remove {
					height: auto;
					background: transparent;
				}
			}
		}
	}
`;
